// extracted by mini-css-extract-plugin
export default {"tabMenu":"CompanyProfile_tabMenu__2l+eT","tabActive":"CompanyProfile_tabActive__3233j","tabContainer":"CompanyProfile_tabContainer__v-n9+"};